import { I18n } from "@/i18n/I18n";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PartParams } from "@/backend/access/part/types";
import { CustomToggle } from "../dropdown/CustomToggle";

interface PartsTableProps {
  parts: PartParams[];
  onDelete: (part: PartParams) => void;
  onView: (partId: string) => void;
}

const PartToggle = CustomToggle('part');

export function PartsTable({ 
  parts, 
  onDelete, 
  onView,
}: PartsTableProps) {
  return (
    <table className='table table-hover mt-3' style={{ tableLayout: 'fixed', width: '100%' }}>
      <colgroup>
        <col style={{ width: '25%' }} />
        <col style={{ width: '60%' }} />
        <col style={{ width: '15%' }} />
      </colgroup>
      <thead className="sticky-top" style={{ boxShadow: 'inset 0 2px 0 #000000, inset 0 -2px 0 #000000' }}>
        <tr>
          <th>{I18n.get('title')}</th>
          <th>{I18n.get('description')}</th>
          <th>{I18n.get('actions')}</th>
        </tr>
      </thead>
      <tbody>
        {parts.length === 0 ? (
          <tr>
            <td colSpan={3} className="text-center py-4">
              <p className="text-muted">{I18n.get('noPartsFound')}</p>
            </td>
          </tr>
        ) : (
          parts.map((part) => (
            <tr key={part.id}>
              <td style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                <Link 
                  to={`/parts/${part.id}`} 
                  className="link-body-emphasis link-offset-2 link-underline-opacity-25 link-underline-opacity-75-hover"
                >
                  {part.title}
                </Link>
              </td>
              <td style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>{part.description}</td>
              <td>
                <Dropdown drop="down">
                  <Dropdown.Toggle size="sm" as={PartToggle} variant="dark" id={`part-dropdown-${part.id}`} />
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => onView(part.id)}>
                      {I18n.get('view')}
                    </Dropdown.Item>
                    <Dropdown.Item className="text-danger" onClick={() => onDelete(part)}>
                      {I18n.get('delete')}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
}
